import React from 'react'
import { Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import CommonToolTip from '../../../tooltip/commonToolTip'
import styles from './InputLabel.module.scss'

interface ILabel {
  label?: React.ReactNode
  children?: React.ReactNode
  className?: string
  tooltip?: string
}

const InputLabel: React.FC<ILabel> = ({
  label,
  children,
  className = undefined,
  tooltip,
}) => {
  const toolTip = (msg: string) => {
    return (
      <CommonToolTip text={msg} className={className}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </CommonToolTip>
    )
  }

  return (
    <Form.Label
      className={`${styles.regularLabelTitle} input-label ${className || ''}`}
    >
      {label || children}
      {tooltip && toolTip(tooltip)}
    </Form.Label>
  )
}

export default InputLabel
